import { useEffect } from "react";
import { List, Wrapper, Scroller } from "./tags-slider.styles";

const Slider = () => {
  useEffect(() => {
    if (!window.matchMedia("(prefers-reduced-motion)").matches) addAnimation();
  }, []);

  const addAnimation = () => {
    const scrollers = document.querySelectorAll(".scroller");
    scrollers.forEach((scroller) => {
      scroller.setAttribute("data-animated", true);
    });
    const scrollerInner = document.querySelector(".scroller__inner");
    const scrollerContent = Array.from(scrollerInner.children);
    scrollerContent.forEach((item) => {
      const duplicatedItem = item.cloneNode(true);
      duplicatedItem.setAttribute("aria-hidden", true);
      scrollerInner.appendChild(duplicatedItem);
    });
  };
  return (
    <Wrapper>
      <Scroller className="scroller" data-direction="left">
        <List className="scroller__inner">
          <li>HTML5</li>
          <li>CSS3</li>
          <li>SASS</li>
          <li>Tailwind</li>
          <li>JavaScript</li>
          <li>React.js</li>
          <li>Next.js</li>
          <li>TypeScript</li>
          <li>Node.js</li>
          <li>Express.js</li>
          <li>MongoDB</li>
          <li>Git</li>
          <li>GitHub</li>
        </List>
      </Scroller>
    </Wrapper>
  );
};
export default Slider;
